export default "__VITE_ASSET__0ddd1e6a__"